import React, { useState, useEffect } from 'react';

const BreaksForm = ({formData, onNavigate}) => {
  const [startDayTime, setStartDayTime] = useState("09:00");
  const [lunchTime, setLunchTime] = useState();
  const [lunchDuration, setLunchDuration] = useState();
  const [dinnerTime, setDinnerTime] = useState();
  const [dinnerDuration, setDinnerDuration] = useState();
  const [doStuffAfterDinner, setDoStuffAfterDinner] = useState(false);
  const [endDayTime, setEndDayTime] = useState("20:00");

  const handleStartDayTimeChange = (event) => {
    setStartDayTime(event.target.value);
};

  const handleLunchTimeChange = (event) => {
    setLunchTime(event.target.value);
    if(lunchDuration == undefined){
      setLunchDuration("2")
    }
};

const handleLunchDurationChange = (event) => {
    setLunchDuration(event.target.value);
};

const handleDinnerTimeChange = (event) => {
    setDinnerTime(event.target.value);
    if(dinnerDuration == undefined){
      setDinnerDuration("2")
    }
};

const handleDinnerDurationChange = (event) => {
    setDinnerDuration(event.target.value);
};

const handleDoStuffAfterDinnerChange = (event) => {
    setDoStuffAfterDinner(event.target.checked);
};

const handleEndDayTimeChange = (event) => {
    setEndDayTime(event.target.value);
};

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!doStuffAfterDinner){
      setEndDayTime(dinnerTime)
    }
    const newData = {
      ...formData,
      start_day_time: startDayTime,
      lunch_time: lunchTime,
      lunch_duration: lunchDuration,
      dinner_time: dinnerTime,
      dinner_duration: dinnerDuration,
      end_day_time: endDayTime
    };
    onNavigate(newData);
  };

  useEffect(() => {
      const selectElements = document.querySelectorAll('select'); 
    
      const handleToggle = (event) => event.target.classList.toggle('select-open');
      const handleOutClick = (event) => event.target.classList.remove('select-open');
    
      selectElements.forEach((select) => {
        select.addEventListener('click', handleToggle);
        select.addEventListener('blur', handleOutClick);
      });
    
      return () => {
        selectElements.forEach((select) => {
          select.removeEventListener('click', handleToggle);
          select.removeEventListener('blur', handleOutClick);
        });
      };
    }, []);

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <header className='form-header'>
          <h1>Breaks</h1>
        </header>
        <div className="form-container">
          <div className='input-datetime'>
              <label className='break-label'>Start daily program at:</label>
              <input
              type="time"
              id="starttime"
              name="starttime"
              value={startDayTime}
              onChange={handleStartDayTimeChange}
              />
          </div>
          <div className='input-datetime'>
              <label className='break-label'>Lunch break start:</label>
              <input
              type="time"
              id="starttime"
              name="starttime"
              value={lunchTime}
              onChange={handleLunchTimeChange}
              />
              <select id="city" className='input-field-regular' name="city" value={lunchDuration} onChange={handleLunchDurationChange}>
                <option value="">duration   </option>
                <option value="0.5">00:30</option>
                <option value="1">01:00</option>
                <option value="1.5">01:30</option>
                <option value="2">02:00</option>
                <option value="2.5">02:30</option>
                <option value="3">03:00</option>
                <option value="3.5">03:30</option>
                <option value="4">04:00</option>
              </select>
          </div>
          <div className='input-datetime'>
              <label className='break-label'>Dinner break start:</label>
              <input
              type="time"
              id="starttime"
              name="starttime"
              value={dinnerTime}
              onChange={handleDinnerTimeChange}
              />
              <select id="city" className='input-field-regular' name="city" value={dinnerDuration} onChange={handleDinnerDurationChange}>
                <option value="">duration   </option>
                <option value="0.5">00:30</option>
                <option value="1">01:00</option>
                <option value="1.5">01:30</option>
                <option value="2">02:00</option>
                <option value="2.5">02:30</option>
                <option value="3">03:00</option>
                <option value="3.5">03:30</option>
                <option value="4">04:00</option>
              </select>
          </div>
          <div className='input-postDinner'>
              <label className='date-label'>Continue sightseeing after dinner?</label>
              <input
              type="checkbox"
              className="accessible-checkbox"
              onChange={handleDoStuffAfterDinnerChange}
              />
          </div>
          {doStuffAfterDinner && 
          <div className='input-datetime'>
              <label className='break-label'>End daily program at:</label>
              <input
              type="time"
              id="starttime"
              name="starttime"
              value={endDayTime}
              onChange={handleEndDayTimeChange}
              />
          </div>}
        </div>
        <button type="submit" >Submit</button>
      </form>
    </div>
  );
};

export default BreaksForm;
